export class GalleryListModel {
    public id: number;
    public name: string;
    public createdOn: string;
    public imageUrl: string;
    public totalDesigns: number;
}



// WEBPACK FOOTER //
// ./src/models/gallery/gallery.list.model.ts